import React from 'react';
import cx from 'classnames';
import { SLDSModal } from '@salesforce/design-system-react';

function Modal({
  className,
  ...props
}) {
  return /*#__PURE__*/React.createElement(SLDSModal, Object.assign({}, props, {
    className: cx(className, "tds-modal")
  }));
}
Modal.displayName = "Modal";
Modal.propTypes = SLDSModal.propTypes;
Modal.defaultProps = SLDSModal.defaultProps;

export { Modal as default };
